import { useMemo } from 'react';

import {
	ADDITIONAL_INFO,
	ADDITIONAL_INFO_BLANK,
	AGREEMENT_BLANK,
	BTN_SEND,
	CHOOSE_SPOKESMAN,
	CHOOSE_VIOLATIONS,
	CLIENT_REQUEST,
	CLIENT_REQUEST_BLANK,
	DATE_BLANK,
	DIAGNOSIS,
	DIAGNOSIS_BLANK,
	EMAIL,
	EMAIL_BLANK,
	FAMILY_NAME,
	FAMILY_NAME_BLANK,
	GENDER_BLANK,
	INFO_TITLE,
	INSTITUTION_BLANK,
	INTERVIEW_DATE_BLANK,
	MAIN_TYPES_VIOALATIONS,
	NAME,
	NAME_BLANK,
	PROGRAM,
	PROGRAM_BLANK,
	QUESTIONS_BLANK,
	SAVE,
	SURNAME,
	SURNAME_BLANK,
	TOOLTIP,
	YEAR,
	YEAR_BLANK,
} from '../../constants';

export const useStepFormText = () => {
	const text = useMemo(
		() => ({
			additionalInfo: ADDITIONAL_INFO,
			additionalInfoBlank: ADDITIONAL_INFO_BLANK,
			agreementBlank: AGREEMENT_BLANK,
			btnSend: BTN_SEND,
			clientRequest: CLIENT_REQUEST,
			clientRequestBlank: CLIENT_REQUEST_BLANK,
			dateBlank: DATE_BLANK,
			diagnosis: DIAGNOSIS,
			diagnosisBlank: DIAGNOSIS_BLANK,
			email: EMAIL,
			emailBlank: EMAIL_BLANK,
			familyName: FAMILY_NAME,
			familyNameBlank: FAMILY_NAME_BLANK,
			genderBlank: GENDER_BLANK,
			infoTitle: INFO_TITLE,
			institutionBlank: INSTITUTION_BLANK,
			interviewDateBlank: INTERVIEW_DATE_BLANK,
			mainTypesViolations: MAIN_TYPES_VIOALATIONS,
			name: NAME,
			nameBlank: NAME_BLANK,
			program: PROGRAM,
			programBlank: PROGRAM_BLANK,
			questionsBlank: QUESTIONS_BLANK,
			save: SAVE,
			surname: SURNAME,
			surnameBlank: SURNAME_BLANK,
			tooltip: TOOLTIP,
			year: YEAR,
			yearBlank: YEAR_BLANK,
			chooseSpokesman: CHOOSE_SPOKESMAN,
			chooseViolations: CHOOSE_VIOLATIONS,
		}),
		[],
	);

	return { text };
};
